// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"78":"3688863a","152":"dde54c77","234":"a7714517","245":"ee0f70f5","314":"11ee01c0","412":"518f0eec","639":"afa50c7d","643":"5596586b","706":"a5e848e9","718":"a474be0c","763":"89660a0c","787":"5dd16890","863":"79d2e108"}[chunkId] + ".chunk.js";
};